module.exports = __webpack_public_path__ + "media/img/vca/sponsors/conspicuousscents-3450b2d5a324f043e8b4956aa302c8e3.png";